import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Dashboard_api } from "../../Apiconfig";
import styles from "./Dashboard_home.module.css";
import { NavLink } from "react-router-dom";

const AccountManagement = () => {
  const [transactions, setTransactions] = useState([]);
  const [error, setError] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [offset, setOffset] = useState(0);
  const limit = 7;

  const tableContainerRef = useRef(null);
  const initialFetchDone = useRef(false); // Flag to prevent duplicate initial fetch

  const fetchTransactions = async (currentOffset) => {
    try {
      const response = await axios.get(
        `${Dashboard_api}transaction_table.php?offset=${currentOffset}&limit=${limit}`,
        { withCredentials: true }
      );

      if (response.data.data) {
        setTransactions((prev) => [...prev, ...response.data.data]);
        setHasMore(response.data.hasMore);
      } else {
        console.error("Unexpected API response:", response.data);
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
      setError("Failed to load transactions. Please try again later.");
    }
  };

  useEffect(() => {
    // Prevent duplicate fetch due to React Strict Mode
    if (!initialFetchDone.current) {
      initialFetchDone.current = true;
      fetchTransactions(0); // Initial fetch
    }
  }, []); // Only runs once

  useEffect(() => {
    if (offset > 0) {
      fetchTransactions(offset); // Fetch additional data when offset changes
    }
  }, [offset]);

  useEffect(() => {
    const handleScroll = () => {
      const container = tableContainerRef.current;
      if (container) {
        const { scrollTop, scrollHeight, clientHeight } = container;
        if (scrollHeight - scrollTop <= clientHeight + 50 && hasMore) {
          setOffset((prevOffset) => prevOffset + limit);
        }
      }
    };

    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [hasMore]);

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Well-Come Admin Dashboard</h2>

      <br />

      <div className="row align-items-center">
        {/* cards section */}
        <div className="col-md-6 text-center">
          <div className={styles.gridContainer}>
            {/* Financial Reports Section */}
            <NavLink to="/Dashboard_panel/billing_panel" className={styles.cards}>
              <div className={styles.section}>
                <i className="fa-solid fa-file-pen"></i>
                <h3>Billing Monitor</h3>
                <div className={styles.toggleSection}>
                  <label>Quickly generate bills for customers:</label>
                </div>
              </div>
            </NavLink>

            {/* Inventory Section */}
            <NavLink to="/Dashboard_panel/inventory_panel" className={styles.cards}>
              <div className={styles.section}>
                <i className="fa-solid fa-box-open"></i>
                <h3>Inventory</h3>
                <div className={styles.toggleSection}>
                  <label>Track Stock Levels and Costs:</label>
                </div>
              </div>
            </NavLink>

            {/* Suppliers Section */}
            <NavLink to="/Dashboard_panel/suppliers_panel" className={styles.cards}>
              <div className={styles.section}>
                <i className="fa-solid fa-truck"></i>
                <h3>Suppliers</h3>
                <div className={styles.toggleSection}>
                  <label>Monitor Supplier Transactions and Dues:</label>
                </div>
              </div>
            </NavLink>

            {/* Customers Section */}
            <NavLink to="/Dashboard_panel/customers_panel" className={styles.cards}>
              <div className={styles.section}>
                <i className="fa-solid fa-users"></i>
                <h3>Customers</h3>
                <div className={styles.toggleSection}>
                  <label>Track Customer Invoices and Payments:</label>
                </div>
              </div>
            </NavLink>
          </div>
        </div>

        {/* table section */}
        <div className="col-md-6 text-center">
          <div className={styles.tablesection}>
            <h3>Today's Transactions</h3>
            {error && <p className={styles.error}>{error}</p>}
            <div
              className={styles.scrollableTableBody}
              ref={tableContainerRef} // Attach ref to the table container
            >
              <table className="table">
                <thead className={styles.tableHead}>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">ID</th>
                    <th scope="col">Customer ID</th>
                    <th scope="col">Total Amount</th>
                    <th scope="col">Paid Amount</th>
                    <th scope="col">Due Amount</th>
                    <th scope="col">Payment Method</th>
                    <th scope="col">Transaction ID</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.length > 0 ? (
                    transactions.map((transaction, index) => (
                      <tr key={transaction.transaction_id || index}>
                        <th>{index + 1}</th>
                        <td>{transaction.id}</td>
                        <td>{transaction.customer_id}</td>
                        <td>{transaction.total_amount}</td>
                        <td>{transaction.paid_amount}</td>
                        <td>{transaction.due_amount}</td>
                        <td>{transaction.payment_method}</td>
                        <td>{transaction.transaction_id}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8">No transactions found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountManagement;
